// Ported from horizontal-actions-dashboard/frontend/src/components/RiskScore.tsx,
// translated from CSS custom properties to MUI styling.

import { TableCell, Box, Chip, Stack } from '@mui/material';

export const RISK_BAND_STYLES: Record<string, { background: string; color: string }> = {
  critical: { background: '#ff1a1a', color: '#ffffff' },
  high: { background: '#8b0000', color: '#ffffff' },
  medium: { background: '#ffc000', color: '#16232b' },
  low: { background: '#2e7d32', color: '#ffffff' },
};

const RISK_BAND_ROWS = [
  { band: 'critical', label: 'Critical', condition: '>=75' },
  { band: 'high', label: 'High', condition: '>=50 and <75' },
  { band: 'medium', label: 'Medium', condition: '>=25 and <50' },
  { band: 'low', label: 'Low', condition: '<25' },
];

export function TerminalsRiskScoreCell({ score, band }: { score: number | null; band: string | null }) {
  const style = score != null ? RISK_BAND_STYLES[band ?? ''] : undefined;
  return (
    <TableCell sx={style ? { backgroundColor: style.background, color: style.color } : undefined}>
      {score != null ? <strong>{score}</strong> : '—'}
    </TableCell>
  );
}

export function TerminalsRiskScoreLegend({ inline = false }: { inline?: boolean } = {}) {
  if (inline) {
    return (
      <Stack direction="row" spacing={1} flexWrap="wrap" justifyContent="flex-end" aria-label="Risk score band legend" sx={{ mt: 1 }}>
        {RISK_BAND_ROWS.map((row) => (
          <Chip
            key={row.band}
            size="small"
            label={`${row.label} ${row.condition}`}
            sx={{
              backgroundColor: `${RISK_BAND_STYLES[row.band].background} !important`,
              borderColor: `${RISK_BAND_STYLES[row.band].background} !important`,
              color: `${RISK_BAND_STYLES[row.band].color} !important`,
              fontWeight: 600,
              '& .MuiChip-label': {
                color: `${RISK_BAND_STYLES[row.band].color} !important`,
              },
            }}
          />
        ))}
      </Stack>
    );
  }

  return (
    <Box component="table" sx={{ borderCollapse: 'collapse', mt: 1 }}>
      <caption style={{ position: 'absolute', left: -9999 }}>Risk score band legend</caption>
      <thead>
        <tr>
          <th style={{ textAlign: 'left', padding: '4px 8px' }} scope="col">
            Risk Score
          </th>
          <th style={{ textAlign: 'left', padding: '4px 8px' }} scope="col">
            Band
          </th>
        </tr>
      </thead>
      <tbody>
        {RISK_BAND_ROWS.map((row) => (
          <tr key={row.band} style={RISK_BAND_STYLES[row.band]}>
            <td style={{ padding: '4px 8px' }}>
              <strong>{row.label}</strong>
            </td>
            <td style={{ padding: '4px 8px' }}>{row.condition}</td>
          </tr>
        ))}
      </tbody>
    </Box>
  );
}
